window.NotifyMe = {
    showModal: function (id, title) {
        let modal = document.querySelector("notify-modal #notify-bis-modal");
        if (!modal) return;

        let productTitleEl = modal.querySelector(".h4.product-title");
        if (productTitleEl) productTitleEl.innerText = title;

        let idInput = modal.querySelector("input[name='notify-id']");
        if (idInput) idInput.value = id;

        modal.classList.remove("hide");
        modal.classList.add("modal-active");
    }
};

if (!customElements.get("notify-modal")) {
    class NotifyModal extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector("form");
            this.errorMessage = this.form.querySelector("#error_message");
            this.closeButton = this.querySelector("button.notify-bis-close");
            this.emailSelector = this.querySelector("ul li[data-value='email']");
            this.phoneSelector = this.querySelector("ul li[data-value='sms']");

            this.closeButton.addEventListener("click", this.hideModal.bind(this));
            this.emailSelector.addEventListener("click", this.emailVisible.bind(this));
            this.phoneSelector.addEventListener("click", this.phoneVisible.bind(this));

            this.submitButton = this.querySelector("button[name='klaviyo-bis-submit']");
            this.submitButton.addEventListener("click", this.handleKlaviyoSubmit.bind(this));
        }

        emailVisible() {
            this.querySelector(".form-group .phone").classList.add("hide");
            this.querySelector(".form-group .email").classList.remove("hide");

            this.emailSelector.classList.add("active");
            this.phoneSelector.classList.remove("active");
            this.handleEmptyState();
        }

        phoneVisible() {
            this.querySelector(".form-group .email").classList.add("hide");
            this.querySelector(".form-group .phone").classList.remove("hide");

            this.phoneSelector.classList.add("active");
            this.emailSelector.classList.remove("active");
            this.handleEmptyState();
        }

        hideModal() {
            this.clearState();
            this.querySelector("#notify-bis-modal").classList.remove("modal-active");
            this.querySelector("#notify-bis-modal").classList.add("hide");
        }

        handleEmptyState() {
            this.errorMessage.innerText = "";
            this.submitButton.classList.remove("hide");
            this.form.querySelector(".success").classList.add("hide");
        }

        clearState() {
            this.querySelector("input[type='email']").value = "";
            this.querySelector("input[name='contact']").value = "";
            this.querySelector(".channel_select ul li").click();
            this.querySelector(".form-errors").innerHTML = "";
        }

        async handleKlaviyoSubmit(evt) {
            evt.preventDefault();

            let formData = {
                varId: this.form.querySelector("input#product").value,
            };

            let channelEl = this.form.querySelector(".channel_select ul li.active");
            let channel = channelEl ? channelEl.dataset.value : 'email';

            if (channel === "email") {
                if (this.form.querySelector(".form-group input#email").value.length < 5) {
                    this.errorMessage.innerText = "Email can't be blank";
                    return;
                } else {
                    this.errorMessage.innerText = "";
                }

                formData.attributes = {
                    email: this.form.querySelector(".form-group input#email").value,
                };
                formData.channel = "EMAIL";
            } else {
                let code = `+${this.form.querySelector("#contact_phoneCode").value}`;
                let number = this.form.querySelector(".phone_box input#contact").value;

                if (number.length < 10) {
                    this.errorMessage.innerText = "Contact can't be blank";
                    return;
                } else {
                    this.errorMessage.innerText = "";
                }
                formData.attributes = {
                    phone_number: `${code}${number}`,
                };
                formData.channel = "SMS";
            }

            const payload = {
                data: {
                    type: "back-in-stock-subscription",
                    attributes: {
                        profile: {
                            data: {
                                type: "profile",
                                attributes: formData.attributes,
                            },
                        },
                        channels: [formData.channel],
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: "catalog-variant",
                                id: `$shopify:::$default:::${formData.varId}`,
                            },
                        },
                    },
                },
            };

            this.submitButton.textContent = "Loading...";

            fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=T5NGfn`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    revision: "2023-12-15",
                },
                body: JSON.stringify(payload),
            })
                .then((response) => {
                    if (response.ok) return;
                    else {
                        return response.json();
                    }
                })
                .then((result) => {
                    this.submitButton.textContent = this.submitButton.dataset.originalText || "Submit";
                    if (result?.errors) {
                        let errorsHTML = ``;
                        result.errors.forEach((error) => (errorsHTML += `<li class="errors">${error.detail}</li>`));
                        let finalErrorsHTML = `<ul>${errorsHTML}</ul>`;

                        this.form.querySelector(".form-errors").innerHTML = finalErrorsHTML;
                    } else {
                        this.form.querySelector(".form-errors").innerHTML = "";
                        this.submitButton.classList.add("hide");
                        this.submitButton.nextElementSibling.classList.remove("hide");
                        setTimeout(() => this.hideModal(), 3000);
                    }
                })
                .catch((error) => {
                    this.submitButton.textContent = "Submit";
                    this.errorMessage.innerText = "An error occurred, please try again.";
                });
        }
    }

    customElements.define("notify-modal", NotifyModal);
}
